import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { PageTitle } from "@/contexts/page-title-context";
function AdminEntitiesLayout({ children }: { children: React.ReactNode }) {
  const { t: tAdminEntities } = useTranslation("admin.entities");

  return (
    <>
      <PageTitle>{tAdminEntities("title")}</PageTitle>
      {children}
    </>
  );
}

export const Route = createFileRoute("/_app/admin/entities")({
  component: function LayoutRoute() {
    return (
      <AdminEntitiesLayout>
        <Outlet />
      </AdminEntitiesLayout>
    );
  },
});
